// extracted by mini-css-extract-plugin
export var markerWrapper = "OfficeList-module--marker-wrapper--32o7A";
export var marker = "OfficeList-module--marker--27sd4";
export var offices = "OfficeList-module--offices--2UZjg";
export var officeItem = "OfficeList-module--office-item--26XMh";
export var content = "OfficeList-module--content--bq_yB";
export var mapWrapper = "OfficeList-module--map-wrapper--3D5-J";
export var styledImage = "OfficeList-module--styled-image--1aAIx";